<template>
  <div>

    <div ref="overview" style="height:400px;"></div>

    <div>
      <span>旷课:{{OverViewData.AbsenteeCount}}</span>
      <span>请假:{{OverViewData.LeaveCount}}</span>
      <span>早退:{{OverViewData.LeaveEarlyCount}}</span>
      <span>迟到:{{OverViewData.LaterCount}}</span>
    </div>


    <div ref="history" style="height:400px;"></div>


    <div ref="historyDetails" style="height:400px;"></div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        apiPath: "/api/StudentAttendanceData/",
        menus: [],
        modal_loading: false,
        loading: true,

        //概览数据
        OverViewData: {},


        chartOverView: null,
        chartHistoryView: null,
        chartHistoryViewDetails: null,

      };
    },
    components: {},
    created: function() {

    },
    mounted: function() {

      this.OverView();
      this.HistoryView();
      this.HistoryViewDetails();


      window.onresize = function () {
        this.chartOverView.resize();
        this.chartHistoryView.resize();
        this.chartHistoryViewDetails.resize();
      };
    },
    methods: {

      //学生考勤概览--仪表盘
      async OverView () {

        // 基于准备好的dom，初始化echarts实例
        this.chartOverView = this.echarts.init(this.$refs.overview);
        // 指定图表的配置项和数据
        let option = {
          title: {
            text: '学生考勤概览'
          },
          tooltip: {
            formatter: "{a} <br/>{b} : {c}%"
          },
          //toolbox: {
          //    feature: {
          //        restore: {},
          //        saveAsImage: {}
          //    }
          //},
          series: [
            {
              name: '全校',
              type: 'gauge',
              detail: { formatter: '{value}%' },
              data: [{ value: 0, name: '考勤率' }]
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        //this.chartOverView.setOption(option);
        this.chartOverView.showLoading();
        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetTodayData'
        );
        if (res.success) {

          option.series[0].data[0].value = res.data.TotalStudentAttendancePercentage;

          this.chartOverView.hideLoading();
          this.chartOverView.setOption(option, true);
          this.OverViewData = res.data;

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }


      },


      //近7天出勤率
      async HistoryView () {

        this.chartHistoryView = this.echarts.init(this.$refs.history);
        let option = {
          title: {
            text: '全校近7天出勤率'
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],//['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [],//[820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            areaStyle: {}
          }]
        };


        //this.chartHistoryView.setOption(option);
        this.chartHistoryView.showLoading();

        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetHistoryData'
        );
        if (res.success) {
          let xAxisDataList = [];
          let seriesDataList = [];
          if(res.data!==null){
            Object.keys(res.data).forEach(function(key){
              xAxisDataList.push(key);
              seriesDataList.push(res.data[key]);
            });
          }

          option.xAxis.data = xAxisDataList;
          option.series[0].data = seriesDataList;

          this.chartHistoryView.hideLoading();
          this.chartHistoryView.setOption(option, true);
        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }


      },


      //近7天出勤率详情
      async HistoryViewDetails () {

        this.chartHistoryViewDetails = this.echarts.init(this.$refs.historyDetails);
        // 指定图表的配置项和数据
        let option = {
          title: {
            text: '全校近7天旷课/请假/早退/迟到走势图'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            show: false,
            //data: [],//['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
          },
          //toolbox: {
          //    feature: {
          //        saveAsImage: {}
          //    }
          //},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: []//['周一', '周二', '周三', '周四', '周五', '周六', '周日']
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [

          ]
        };

        //this.chartHistoryViewDetails.setOption(option);
        this.chartHistoryViewDetails.showLoading();
        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetHistoryDetailsData'
        );
        if (res.success) {
          option.xAxis[0].data = res.data.DayList;
          option.series = res.data.DetailsList;

          this.chartHistoryViewDetails.hideLoading();
          this.chartHistoryViewDetails.setOption(option, true);

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }


      },
    }
  };
</script>
<style lang='less' >

</style>

